<template>
  <div class="layout--main" :class="[navbarClasses, footerClasses, { 'app-page': isAppPage }]">
    <vx-tour :steps="tourMenuLateral.steps" :callbacks="tourMenuLateral.callbacks" v-if="!tourMenuLateral.completed" />

    <the-customizer
      @updateNavbar="updateNavbar"
      @updateNavbarColor="updateNavbarColor"
      :navbarType="navbarType"
      :navbarColor="navbarColor"
      :footerType="footerType"
      @updateFooter="updateFooter"
      :routerTransition="routerTransition"
      @updateRouterTransition="updateRouterTransition"
      v-if="!disableCustomizer"
      :hideScrollToTop="hideScrollToTop"
      @toggleHideScrollToTop="toggleHideScrollToTop"
    />
    <vx-sidebar
      :sidebarItems="sidebarItems"
      :logo="`/assets/images/logo/logo_main_${appFilename}.svg`"
      :demo-link-prefix="demoLinkPrefix"
      title
      parent=".layout--main"
    />

    <div id="content-area" :class="[contentAreaClass, { 'show-overlay': bodyOverlay }]">
      <div id="content-overlay"></div>

      <div class="content-wrapper">
        <the-navbar
          :navbarColor="navbarColor"
          :class="[{ 'text-white': isNavbarDark && !isThemeDark }, { 'text-base': !isNavbarDark && isThemeDark }]"
        />

        <div class="router-view">
          <div class="router-content" :class="{ 'mt-0': navbarType == 'hidden' }">
            <transition :name="routerTransition">
              <!-- comenta router header na table
                        <div class="router-header flex flex-wrap items-center mb-6" v-if="$route.meta.breadcrumb || $route.meta.pageTitle">
                            <div class="content-area__heading" :class="{'pr-4 border-0 md:border-r border-t-0 border-b-0 border-l-0 border-solid border-grey-light' : $route.meta.breadcrumb}">
                                <h2 class="mb-1">{{ routeTitle }}</h2>
                            </div>


                            <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb" />


                            <vs-dropdown class="ml-auto md:block hidden cursor-pointer" vs-trigger-click>
                                <vs-button radius icon="icon-settings" icon-pack="feather"></vs-button>

                                <vs-dropdown-menu class="w-32">

                                    <vs-dropdown-item>
                                      <div @click="$router.push('/pages/profile')" class="flex items-center">
                                        <feather-icon icon="UserIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                                        <span>Profile</span>
                                      </div>
                                    </vs-dropdown-item>

                                    <vs-dropdown-item>
                                      <div @click="$router.push('/apps/todo')" class="flex items-center">
                                        <feather-icon icon="CheckSquareIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                                        <span>Tasks</span>
                                      </div>
                                    </vs-dropdown-item>

                                    <vs-dropdown-item>
                                      <div @click="$router.push('/apps/email')" class="flex items-center">
                                        <feather-icon icon="MailIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                                        <span>Inbox</span>
                                      </div>
                                    </vs-dropdown-item>
                                </vs-dropdown-menu>
                            </vs-dropdown>
                        </div>
              -->
            </transition>
            <div class="content-area__content">
              <back-to-top bottom="5%" visibleoffset="500" v-if="!hideScrollToTop">
                <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg" />
              </back-to-top>
              <transition :name="routerTransition" mode="out-in">
                <div v-if="functionProAppOnly" class="mb-10">
                  <div class="con-vs-alert con-vs-alert-danger mb-4">
                    <div class="vs-alert text-center">Ops... Essa função só está disponível para o aplicativo PRO.</div>
                  </div>

                  <div class="text-center">
                    <a href="https://spyou.com.br/aplicativo-pro" class="vs-component vs-button vs-button-warning vs-button-relief mt-3 mr-2 text-white">
                      <span class="vs-button-text vs-button--text"> <i class="fas fa-mobile"></i> </span>
                      <span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%)"></span>

                      Clique aqui para Conhecer
                    </a>
                  </div>
                </div>
              </transition>
              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle"></router-view>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VxSidebar from '@/layouts/components/vx-sidebar/VxSidebar.vue';
import TheCustomizer from '../components/customizer/TheCustomizer.vue';
import TheNavbar from '../components/TheNavbar.vue';
import themeConfig from '@/../themeConfig.js';
import sidebarItems from '@/layouts/components/vx-sidebar/sidebarItems.js';
import { demoMobile } from '@/demo/fixtures';
import BackToTop from 'vue-backtotop';
import _ from 'lodash';
const VxTour = () => import('@/components/VxTour.vue');

export default {
  data() {
    return {
      appFilename: process.env.VUE_APP_FILENAME,
      navbarType: themeConfig.navbarType || 'floating',
      navbarColor: themeConfig.navbarColor || '#fff',
      footerType: themeConfig.footerType || 'static',
      routerTransition: themeConfig.routerTransition || 'none',
      isNavbarDark: false,
      routeTitle: this.$route.meta.pageTitle,
      sidebarItems: sidebarItems,
      disableCustomizer: themeConfig.disableCustomizer,
      windowWidth: window.innerWidth, //width of windows
      hideScrollToTop: themeConfig.hideScrollToTop,
      tourMenuLateral: {
        completed: false,
        callbacks: {
          onStop: this.tourMenuLateralStop,
        },
        steps: [],
      },
      functionProAppOnly: false,
    };
  },
  mounted: function () {
    this.tourMenuLateral.completed = this.$localStorage.get('tourMenuLateralCompleted');

    this.reloadMenu();

    this.$EventBus.$on('deviceChanged', (dispositivo) => {
      this.$localStorage.set('mobile', null);
      this.$localStorage.set('desktop', null);

      if (dispositivo && dispositivo.uid) {
        this.$localStorage.set('mobile', JSON.stringify(dispositivo));
      } else if (dispositivo && dispositivo.licencekey) {
        this.$localStorage.set('desktop', JSON.stringify(dispositivo));
      }

      this.reloadMenu();
    });
  },
  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;

      let mobile = null;
      try {
        const raw = this.$localStorage.get('mobile');
        if (raw) mobile = JSON.parse(raw);
      } catch (e) {
        mobile = null;
      }
      if (this.$route.path.startsWith('/demo')) {
        mobile = demoMobile;
      }
      this.functionProAppOnly = !!(mobile && mobile.packagename && mobile.packagename.indexOf('.light') > -1 && this.$route.meta.proAppOnly);
      this.reloadMenu();
    },
    isThemeDark(val) {
      if (this.navbarColor === '#fff' && val) {
        this.updateNavbarColor('#10163a');
      } else {
        this.updateNavbarColor('#fff');
      }
    },
  },
  computed: {
    isAppPage() {
      if (this.$route.path.includes('/apps/')) return true;
      else return false;
    },
    isThemeDark() {
      return this.$store.state.theme == 'dark';
    },
    sidebarWidth() {
      return this.$store.state.sidebarWidth;
    },
    bodyOverlay() {
      return this.$store.state.bodyOverlay;
    },
    contentAreaClass() {
      if (this.sidebarWidth == 'default') return 'content-area-default';
      else if (this.sidebarWidth == 'reduced') return 'content-area-reduced';
      else if (this.sidebarWidth) return 'content-area-full';
    },
    navbarClasses() {
      return {
        'navbar-hidden': this.navbarType == 'hidden',
        'navbar-sticky': this.navbarType == 'sticky',
        'navbar-static': this.navbarType == 'static',
        'navbar-floating': this.navbarType == 'floating',
      };
    },
    footerClasses() {
      return {
        'footer-hidden': this.footerType == 'hidden',
        'footer-sticky': this.footerType == 'sticky',
        'footer-static': this.footerType == 'static',
      };
    },
    demoLinkPrefix() {
      return this.$route.path.startsWith('/demo') ? '/demo' : '';
    },
  },
  methods: {
    reloadMenu() {
      _.each(this.sidebarItems, (sidebarItem) => {
        sidebarItem.visible = sidebarItem.visibleAny || false;

        try {
          // mobile
          let mobile = null;
          try {
            const raw = this.$localStorage.get('mobile');
            if (raw) mobile = JSON.parse(raw);
          } catch (e) {
            mobile = null;
          }
          if (this.$route.path.startsWith('/demo')) {
            mobile = demoMobile;
          }
          if (mobile && mobile.count) {
            if (sidebarItem.visibleMobile || (sidebarItem.url && sidebarItem.url.indexOf('/mobile') > -1)) {
              if (
                typeof sidebarItem.panelVersion === 'undefined' ||
                (sidebarItem.panelVersion >= 0 && sidebarItem.panelVersion === mobile.panel_version)
              ) {
                sidebarItem.visible = true;
              } else {
                sidebarItem.visible = false;
              }
            }

            _.each(mobile.count, function (count, key) {
              if (sidebarItem.name == key) {
                sidebarItem.tag = count;
              }
            });
          }
        } catch (error) {
          // ignored
        }

        // desktop
        let desktop = JSON.parse(this.$localStorage.get('desktop'));
        if (desktop && desktop.count) {
          if (sidebarItem.visibleDesktop || (sidebarItem.url && sidebarItem.url.indexOf('/desktop') > -1)) {
            sidebarItem.visible = true;
          }

          _.each(desktop.count, function (count, key) {
            if (sidebarItem.name == key) {
              sidebarItem.tag = count;
            }
          });
        }
      });
    },
    changeRouteTitle(title) {
      this.routeTitle = title;
    },
    updateNavbar(val) {
      if (val == 'static') this.updateNavbarColor('#fff');
      this.navbarType = val;
    },
    updateNavbarColor(val) {
      this.navbarColor = val;
      if (val == '#fff') this.isNavbarDark = false;
      else this.isNavbarDark = true;
    },
    updateFooter(val) {
      this.footerType = val;
    },
    updateRouterTransition(val) {
      this.routerTransition = val;
    },
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
      this.setSidebarWidth();
    },
    setSidebarWidth() {
      if (this.windowWidth < 1200) {
        this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', false);
        this.$store.dispatch('updateSidebarWidth', 'no-sidebar');
        this.tourMenuLateral.completed = true;
      } else if (this.windowWidth < 1200) {
        this.$store.dispatch('updateSidebarWidth', 'reduced');
      } else {
        this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', true);
      }
    },
    toggleHideScrollToTop(val) {
      this.hideScrollToTop = val;
    },
    tourMenuLateralStop() {
      this.$localStorage.set('tourMenuLateralCompleted', true);
    },
  },
  components: {
    VxSidebar,
    TheNavbar,
    TheCustomizer,
    BackToTop,
    VxTour,
  },
  created() {
    this.setSidebarWidth();
    if (this.navbarColor == '#fff' && this.isThemeDark) {
      this.updateNavbarColor('#10163a');
    } else {
      this.updateNavbarColor(this.navbarColor);
    }
  },
};
</script>
